import { text_mod_27, } from "../text/Text.js";
export const module27 = {
  title:
    "Літера Ч велика",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_27,
    },
  ]
};